<template>
  <div class="div-background-image">
  <div class="body-width divcss5 div-padding-top">
   <div @click="setroters('/producthhmnq/productcp')" class="div-float-left">
   <a class="product_content_title1">{{$t("product.product1")}}</a>
   </div>
   <!-- <div  @click="setroters('/productzncy/zncajkzzx')" class="div-float-right"></div>
  </div>
    <div class=" row body-width divcss5 div-padding-top1">
   <div @click="setroters('/producthsyl/VTSzhylxt')" class="div-float-left1"></div>
    <div @click="setroters('/productvr')" class="div-float-left2"></div>
   <div @click="setroters('/producthlwhhjy')" class="div-float-right1"></div> -->
      <div @click="setroters('/producthhxnsx/hhxnxl')" class="div-float-left1">
      <a class="product_content_title1">{{$t("product.product8")}}</a>
      </div>
      <div @click="setroters('/productznhy/zncbajyckzz')" class="div-float-right">
      <a class="product_content_title1">{{$t("product.product9")}}</a>
      </div>
      <div @click="setroters('/producthhwhyx/hhwhyxgkj')" class="div-float-right1">
      <a class="product_content_title1">{{$t("product.product10")}}</a>
      </div>
     </div>
  </div>
</template>

<script>
  export default {
      name: "productdetailbanner",
         methods: {
   setroters(src) {
          this.$router.push(src);
   }
         }
  }
</script>

<style scoped>
.div-background-image{
  background: url(../../../assets/images/banner-500/productdetail.jpg);
  background-repeat:no-repeat;
  background-size:100% ;
    margin:0 auto;
    /* border:1px solid #000; */
    width: 1920px;
    height: 500px;
}
.div-float-left{
 float: left;
 background: url(../../../assets/images/productcenter/8.png);
  background-repeat:no-repeat;
  background-size:100% ;
   margin:0 auto;
    /* border:1px solid #000; */
      width: 235px;
      height: 180px;
      cursor: pointer;
        margin:0 auto;
      position: relative;
      top: 150px
}



.div-float-right
{
  
   float: right;
   background: url(../../../assets/images/productcenter/10.png);
  background-repeat:no-repeat;
  background-size:100% ;
    margin:0 auto;
    /* border:1px solid #000; */
    width: 235px;
    height: 180px;
      cursor: pointer;
      position: relative;
      top: 150px;
      left: -300px
}


.div-float-left1{
 float: left;
 background: url(../../../assets/images/productcenter/9.png);
  background-repeat:no-repeat;
  background-size:100% ;
    margin:0 auto;
    /* border:1px solid #000; */
      width: 235px;
      height: 180px;
      cursor: pointer;
      position: relative;
      top: 150px;
      left: 100px
}


.div-float-right1
{
  
   float: right;
  background: url(../../../assets/images/productcenter/11.png);
  background-repeat:no-repeat;
  background-size:100% ;
    margin:0 auto;
    /* border:1px solid #000; */
    width: 235px;
    height: 180px;
    cursor: pointer;
    position: relative;
    top: 150px;
    left: 270px
}

.product_content_title1{
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 16px;
  top: 180px
  }







.div-padding-top{
  padding-top: 90px;
}
.div-padding-top1{
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/productdetailbanner.vue